export enum EChannel {
  WHATSAPP = 'WHATSAPP',
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

export type TOtpParams = {
  channel: EChannel
  phone_number?: string
  email?: string
  noCredentials?: boolean
}

export type TGetOtpResult = {
  access_token: string
  attempt: number
  masked_phone_number?: string
  token_verifier: string
  remainingSeconds?: number
}

export type TSetSessionParams = {
  accessToken: string
  refreshToken: string
  username: string
  partnerId?: string
  isGuest?: string
  authPartnerUrl?: string
}

export type TSession = {
  accessToken: string
  refreshToken: string
  sessionExpires: number
  exp: number
  username: string
  aud: string
  partnerId?: string
  isGuest?: string
  isBanned?: boolean
  emailVerified: boolean
  isFinishedOnboarding: boolean
  authPartnerUrl?: string
}

export type TForgotPinParams = {
  username: string | null
  withOtp?: boolean
}

export type TForgotPinResponse = {
  email: string
  full_name: string
  phone_number: string
  remainingSeconds: number
}

export type TGetEmailVerificationParams = {
  email: string
  isUpdate?: boolean
  withOtp?: boolean
}
